import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Mail, Phone, ExternalLink } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [contact, setContact] = useState(null);

  useEffect(() => {
    axios.get(`${API}/content/contact`)
      .then(res => setContact(res.data))
      .catch(() => {
        setContact({
          email: "journeysntales@gmail.com",
          phone: "+919717841166",
          instagram: "https://www.instagram.com/journeysntalesdel/",
          linkedin: "https://www.linkedin.com/in/pancaj-guptaa-557549195/"
        });
      });
  }, []);

  const email = contact?.email || "journeysntales@gmail.com";
  const phone = contact?.phone || "+919717841166";
  const instagram = contact?.instagram || "https://www.instagram.com/journeysntalesdel/";
  const linkedin = contact?.linkedin || "https://www.linkedin.com/in/pancaj-guptaa-557549195/";

  const extraLinks = [1, 2, 3, 4]
    .map(n => ({
      label: contact?.[`social_link_${n}_label`],
      url: contact?.[`social_link_${n}`]
    }))
    .filter(l => l.label && l.url);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_071d5548-d385-4daa-a48c-997f978ccc70/artifacts/mlh0ioi5_JNT%20LOGO%20Only%20Round.png" 
              alt="Journeys N Tales" 
              className="footer-logo"
            />
            <p className="footer-tagline">Bespoke Global Experiences, Curated Privately.</p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Explore</h3>
            <nav className="footer-links">
              <Link to="/about" className="footer-link" data-testid="footer-about-link">About</Link>
              <Link to="/experiences" className="footer-link" data-testid="footer-experiences-link">Experiences</Link>
              <Link to="/design-journey" className="footer-link" data-testid="footer-design-journey-link">Design My Journey</Link>
              <Link to="/contact" className="footer-link" data-testid="footer-contact-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Contact</h3>
            <div className="footer-contact">
              <a 
                href={`mailto:${email}`} 
                className="footer-contact-item"
                data-testid="footer-email-link"
              >
                <Mail size={18} />
                <span>{email}</span>
              </a>
              <a 
                href={`tel:${phone}`} 
                className="footer-contact-item"
                data-testid="footer-phone-link"
              >
                <Phone size={18} />
                <span>{phone}</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Follow Us</h3>
            <div className="footer-social">
              <a 
                href={instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                title="Follow us on Instagram"
                data-testid="footer-instagram-link"
              >
                <Instagram size={20} />
              </a>
              <a 
                href={linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-social-link"
                title="Connect on LinkedIn"
                data-testid="footer-linkedin-link"
              >
                <Linkedin size={20} />
              </a>
            </div>
            {extraLinks.length > 0 && (
              <div className="footer-extra-links" data-testid="footer-extra-links">
                {extraLinks.map((link, i) => (
                  <a
                    key={i}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="footer-extra-link"
                    data-testid={`footer-extra-link-${i + 1}`}
                  >
                    <ExternalLink size={14} />
                    <span>{link.label}</span>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Journeys N Tales. All rights reserved.</p>
          <p className="footer-privacy">Privacy Policy | Terms of Service</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
